module.exports = __webpack_public_path__ + "assets/img/box7-img.b61d8463.png";